import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Select from '../../../../../../../../../1stlog-ui/src/components/Select'
import Field from '../../../../../../../../../1stlog-ui/src/components/Field'
import i18next from 'i18next'

const Wrapper = styled.div`
  width: 300px;
`

const WaveDisposition = (props) => {
  const {} = props

  const options = useMemo(() => {
    return lodash.map(global.groups, (t) => ({ value: t, label: t }))
  }, [])

  return (
    <Wrapper className="mb-1">
      <Field name="wave">
        <Select placeholder={i18n.t(`select_wave`, `Welle wählen...`)} direct options={options} />
      </Field>
    </Wrapper>
  )
}

export default WaveDisposition
